import { deviceDisplayTypes, DEVICES_PAGE_TAB } from 'common/utils/constants';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeviceHeaderCheckBox } from '../DeviceCheckBox';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { setDeviceDisplayMode, handleSort } from 'redux/actions';
import DeviceTableHeaderResizeSlider from '../DeviceTableHeaderResizeSlider';

const DeviceTableDeviceIdAndNameHeader = ({ forAlarmMap, hasCheckbox, deviceTableSet, devices, onlyDeviceId }) => {
  const devicesPage = useSelector((store) => store.ui.devicesPage);
  const activeTab = devicesPage.activeTab;
  let displayType;
  switch (activeTab) {
    case DEVICES_PAGE_TAB.pivot:
      displayType = devicesPage.pivotTab.deviceDisplayMode;
      break;
    case DEVICES_PAGE_TAB.echo:
      displayType = devicesPage.echoTab.deviceDisplayMode;
      break;
    case DEVICES_PAGE_TAB.all:
      displayType = devicesPage.allDevicesTab.deviceDisplayMode;
      break;
    default:
      displayType = deviceDisplayTypes.ID;
  }
  const isDeviceId = displayType === deviceDisplayTypes.ID;
  const dispatch = useDispatch();
  let deviceColHeader = 'Device ID';

  switch (displayType) {
    case deviceDisplayTypes.ID:
      deviceColHeader = 'Device ID';
      break;
    case deviceDisplayTypes.NAME:
      deviceColHeader = 'Device Name';
      break;
    default:
      break;
  }

  return (
    <div className="DeviceTable_Header_OuterDiv" data-tip={deviceColHeader}>
      {!forAlarmMap && !onlyDeviceId && (
        <DeviceHeaderCheckBox devices={devices} hasCheckbox={hasCheckbox} deviceTableSet={deviceTableSet} />
      )}
      {!onlyDeviceId && (
        <div className="idNameSwitcher">
          <SvgAF
            img={isDeviceId ? IconLoader.icon_toggle_id : IconLoader.icon_toggle_name}
            hover={isDeviceId ? IconLoader.icon_toggle_id_hover : IconLoader.icon_toggle_name_hover}
            tooltip={isDeviceId ? 'Toggle to Name' : 'Toggle to ID'}
            onClick={() => {
              dispatch(setDeviceDisplayMode(isDeviceId ? deviceDisplayTypes.NAME : deviceDisplayTypes.ID));
            }}
          />
        </div>
      )}
      <IconAndText
        img={IconLoader.icon_table_sort}
        hoverImg={IconLoader.icon_table_sort_hover}
        text={deviceColHeader}
        reverse
        onClick={() => dispatch(handleSort(activeTab, 'deviceTable', `${isDeviceId ? 'deviceId' : 'userLabel'}`))}
      />
      {!forAlarmMap ? <DeviceTableHeaderResizeSlider /> : null}
    </div>
  );
};

export default DeviceTableDeviceIdAndNameHeader;
